import React, { Component } from 'react'
import Select from 'react-select'
import CategoryFilterEdit from '../Utils/CategoryFilterEdit'
import { withAuth } from '../AuthContext'
import { Link, withRouter } from 'react-router-dom'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { withSearch } from '../SearchContext'
import { shouldTranslateTo } from '../../utils/utils'
import ImageUploading from 'react-images-uploading'
import Error from '../Utils/Error'
import { Nav, Tab, TabContainer } from 'react-bootstrap'
import styled from 'styled-components'
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa'
import { FaTrash, FaEdit } from 'react-icons/fa'
import { Button, Spinner } from 'react-bootstrap'

const TabsContainer = styled(TabContainer)`
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
`

const CustomNav = styled(Nav)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 5px;
  }
`

const NavItemContainer = styled(Nav.Item)`
  flex: 1;
  text-align: center;
`

const NavLinkContainer = styled(Nav.Link)`
  display: block;
  width: 100%;
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#fff' : '#6c757d')};
  background-color: ${({ active }) => (active ? '#007bff' : '#f1f1f1')};
  cursor: pointer;
  text-decoration: none;
  border: ${({ active }) => (active ? '1px solid #007bff' : '1px solid #ddd')};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ active }) => (active ? '#0056b3' : '#e2e6ea')};
  }

  &:focus {
    outline: none;
    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.5);
  }

  @media (max-width: 576px) {
    font-size: 14px;
  }
`

class EditPlace extends Component {
  constructor(props) {
    super(props)
    const u = this.props.auth.user
    this.state = {
      user: {
        locationId: u.locationId ?? '',
        city: u.city ?? '',
        address_line: u.address_line ?? '',
        second_address_line: u.second_address_line ?? '',
        county: u.county ?? '',
        postcode: u.postcode ?? '',
        countryId: u.countryId,
      },
      place: {
        hostPrice: '',
        placeDescription: '',
        placePhotoDescription: '',
        inviteGuest: 1,
        id: '',
        livesOnProperty: null,
        petInfo: '',
      },
      filters: [],
      allFilters: [],
      filterOptions: [],
      filterOptionIds: [],
      countries: [],
      cities: [],
      currencies: [],
      error: {},
      file: null,
      loading: false,
      photos: [],
      photoBlobs: [],
      captions: [],
      placeAlreadyExists: null,
      currencyError: '',
      breakfastOnlyError: '',
      currentStep: 'listingInfo',
      tabCompletion: {
        listingInfo: false,
        propertyDetails: false,
        uploadImages: false,
        preferences: false,
      },
      propertySubmitted: false,
      showProofOfAddress: false,
      showPetInfoInput: false,
      pageText: [],
    }

    this.handlePlaceInputChange = this.handlePlaceInputChange.bind(this)
    this.handleUserInputChange = this.handleUserInputChange.bind(this)
    this.handlePlaceTypeChange = this.handlePlaceTypeChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.navigateToDashboard = this.navigateToDashboard.bind(this)
    this.getCities = this.getCities.bind(this)
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleGuestChange = this.handleGuestChange.bind(this)
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.handlePhotosChange = this.handlePhotosChange.bind(this)
    this.handleCaptionsChange = this.handleCaptionsChange.bind(this)
    this.handleImageRemove = this.handleImageRemove.bind(this)
    this.checkForErrors = this.checkForErrors.bind(this)
    this.handleStepChange = this.handleStepChange.bind(this)
    this.getBlob = this.getBlob.bind(this)
    this.handleLivesOnPropertyChange =
      this.handleLivesOnPropertyChange.bind(this)
  }

  componentDidMount() {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          this.setState({
            pageText: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('add-edit-place', language)

    if (this.props.auth.user.countryId) {
      this.getCities(this.props.auth.user.countryId)
    }

    this.setState({ countries: this.props.search.countriesNice })

    axios
      .get('/api/places')
      .then((response) => {
        // Extract existing values from the response or use fallback values
        const {
          place = {},
          filters = [],
          filterOptionIds = [],
          placePhotos = [],
          captions = [],
        } = response.data || {} // Use an empty object as default if response.data is undefined

        const user = this.state.user
        const completePlace = {
          currencyId: null,
          typePlace: '',
          placeDescription: '',
          locationDescription: '',
          hostPrice: null,
          livesOnProperty: null,
          petInfo: null,
          ...place,
        }

        const completeUser = {
          locationId: null,
          address_line: '',
          second_address_line: '',
          city: '',
          county: '',
          postcode: '',
          countryId: null,
          ...user, // Spread the actual user values to override defaults if present
        }

        const allowPetsOptionId = 24
        const isPetAllowed =
          filterOptionIds &&
          filterOptionIds.length > 0 &&
          filterOptionIds.includes(allowPetsOptionId)

        if (isPetAllowed && completePlace.petInfo !== null) {
          completePlace.petInfo = place.petInfo
        }

        const isSectionComplete = {
          listingInfo: Boolean(
            completePlace.currencyId &&
              completePlace.typePlace &&
              completePlace.placeDescription &&
              completePlace.locationDescription &&
              completePlace.hostPrice &&
              completePlace.livesOnProperty
          ),
          preferences: Boolean(filterOptionIds && filterOptionIds.length > 0),
          propertyDetails: Boolean(
            completeUser.locationId &&
              completeUser.address_line &&
              completeUser.city &&
              completeUser.county &&
              completeUser.postcode &&
              completeUser.countryId
          ),
          uploadImages: Boolean(placePhotos && placePhotos.length > 0),
        }

        const isPropertySubmitted = place.status === 'proof-uploaded'
        let showProofOfAddress = false
        let propertySubmitted = false

        const allSectionsVerified =
          Object.values(isSectionComplete).every(Boolean)

        if (!isPropertySubmitted && allSectionsVerified) {
          showProofOfAddress = true
        }

        if (isPropertySubmitted) {
          Object.keys(isSectionComplete).forEach((key) => {
            isSectionComplete[key] = true
          })
          propertySubmitted = true
          showProofOfAddress = false
        }

        this.setState(
          {
            place: completePlace,
            filters,
            filterOptionIds: filterOptionIds || [],
            photos: placePhotos,
            captions: captions || [],
            placeAlreadyExists: 'y',
            tabCompletion: isSectionComplete,
            photoBlobs: new Array(placePhotos?.length || 0),
            currentStep: 'listingInfo', // Start at the default tab
            showPetInfoInput: isPetAllowed,
            propertySubmitted: isPropertySubmitted,
            showProofOfAddress: showProofOfAddress,
          },
          () => {
            this.state.photos.forEach((photo, index) => {
              this.getBlob(photo, index)
            })

            const nextTab = this.getNextIncompleteTab(isSectionComplete)
            this.handleStepChange(nextTab)
          }
        )
      })
      .catch((error) => {
        console.log('Request failure: ', error)
      })

    axios
      .get('/api/filters')
      .then((response) => {
        this.setState({ allFilters: response.data })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })

    axios
      .get('/api/filteroptions')
      .then((response) => {
        this.setState({ filterOptions: response.data })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })

    axios
      .get('/api/currencies')
      .then((response) => {
        this.setState({
          currencies: response.data.map((c) => {
            return { value: c.id, label: c.ISO }
          }),
        })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })

    window.scrollTo(0, 0)
  }

  handleLivesOnPropertyChange = (selectedOption) => {
    this.setState((prevState) => ({
      place: {
        ...prevState.place,
        livesOnProperty: selectedOption ? selectedOption.value : null,
      },
    }))
  }

  getBlob = async (photo, index) => {
    const blob = await fetch(photo['data_url']).then((res) => res.blob())
    const newItem = {
      data_url: photo['data_url'],
      file: blob,
    }
    var tempArr = this.state.photoBlobs
    tempArr.splice(index, 1, newItem)
    this.setState({
      photoBlobs: tempArr,
    })
  }

  getCities(countryId) {
    axios
      .get(`/api/cities/${countryId}`)
      .then((response) => {
        this.setState({
          cities: response.data.map((c) => {
            return { value: c.id, label: c.city }
          }),
        })
      })
      .catch(function (error) {
        console.log('Request failure: ', error)
      })
  }

  handlePlaceVisibility = () => {
    this.setState((prevState) => ({
      place: {
        ...prevState.place,
        visibility: !prevState.place.visibility,
      },
    }))
  }

  navigateToDashboard = () => {
    window.location.href = '/myfreebird'
  }

  handlePlaceInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState((prevState) => {
      prevState.place[name] = value
      return prevState
    })
  }

  handleUserInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState((prevState) => {
      prevState.user[name] = value
      return prevState
    })
  }

  handleStepChange = (step) => {
    this.setState({ currentStep: step })
  }

  async handleCountryChange({ value }) {
    this.setState((prevState) => {
      prevState.user.countryId = value
      return prevState
    })
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let cities = response.data.map((city) => {
        return { label: city.city, value: city.id }
      })
      this.setState({ cities })
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  handleCityChange(option) {
    this.setState((prevState) => {
      prevState.user.locationId = option.value
      prevState.user.city = option.label
      return prevState
    })
  }

  editListingInfo = () => {
    this.setState({
      propertySubmitted: false,
      currentStep: 'listingInfo',
    })
  }

  handleCurrencyChange({ value }) {
    this.setState((prevState) => {
      prevState.place.currencyId = value
      prevState.currencyError = ''
      prevState.error = {}
      return prevState
    })
  }

  handlePlaceTypeChange({ label }) {
    this.setState((prevState) => {
      prevState.place.typePlace = label
      prevState.propertyTypeError = ''
      prevState.error = {}
      return prevState
    })
  }

  isListingInfoComplete = () => {
    const { place } = this.state
    return (
      place.currencyId &&
      place.typePlace &&
      place.placeDescription &&
      place.locationDescription &&
      place.hostPrice &&
      place.livesOnProperty
    )
  }

  isPreferencesComplete = () => {
    const { filterOptionIds } = this.state
    return filterOptionIds && filterOptionIds.length > 0
  }

  isPropertyDetailsComplete = () => {
    const { user } = this.state
    return (
      user.locationId &&
      user.address_line &&
      user.city &&
      user.county &&
      user.postcode &&
      user.countryId
    )
  }

  isUploadImagesComplete = () => {
    const { photos } = this.state
    return photos && photos.length >= 0 // assuming at least 5 photos are required
  }

  runStepValidation = (step) => {
    const { place, filterOptionIds } = this.state

    switch (step) {
      case 'listingInfo': // "Listing Info" step
        if (!place.currencyId) return this.state.pageText[0]
        if (!place.typePlace) return this.state.pageText[1]
        return null

      case 'propertyDetails': // "Location Info" step
        if (!place.locationDescription) return this.state.pageText[2]
        return null

      case 'uploadImages': // "Upload Images" step
        if (filterOptionIds.length === 0) return this.state.pageText[3]
        return null

      default:
        return null
    }
  }

  handleGuestChange({ value }) {
    this.setState((prevState) => {
      prevState.place.inviteGuest = value
      return prevState
    })
  }

  handleFilterChange(event) {
    const target = event.target
    const filterId = parseInt(target.dataset.filterId)
    const isGuestPetsFilter = filterId === 7
    const allowGuestPets = isGuestPetsFilter && target.value === '24'
    const disallowGuestPets = isGuestPetsFilter && target.value === '25'

    if (target.type === 'checkbox') {
      this.setState((prevState) => {
        const updatedIds = target.checked
          ? [...prevState.filterOptionIds, parseInt(target.value)]
          : prevState.filterOptionIds.filter(
              (id) => id !== parseInt(target.value)
            )

        return {
          filterOptionIds: updatedIds,
          place: { ...prevState.place, filterOptionId: updatedIds.toString() },
        }
      })
    } else if (target.type === 'radio') {
      const selected = this.state.filterOptions.find(
        (fo) => fo.id == target.value
      )
      const otherFilters = this.state.filterOptions.filter(
        (fo) => fo.filterId == selected.filterId
      )

      this.setState((prevState) => {
        const updatedIds = [
          ...prevState.filterOptionIds.filter(
            (id) => !otherFilters.some((f) => f.id === id)
          ),
          parseInt(target.value),
        ]

        return {
          filterOptionIds: updatedIds,
          place: {
            ...prevState.place,
            filterOptionId: updatedIds.toString(),
            petInfo: allowGuestPets
              ? prevState.place.petInfo
              : disallowGuestPets
                ? ''
                : prevState.place.petInfo,
          },
          showPetInfoInput: allowGuestPets,
        }
      })
    }
  }

  addStepSpecificData = (formData, data) => {
    const { place, filterOptionIds, photos, captions, user, photoBlobs } = data

    // Listing Info fields
    if (this.isListingInfoComplete()) {
      formData.append(
        'place',
        JSON.stringify({
          currencyId: place.currencyId,
          typePlace: place.typePlace,
          placeDescription: place.placeDescription || '',
          locationDescription: place.locationDescription || '',
          hostPrice: place.hostPrice || 20,
          livesOnProperty: place.livesOnProperty ?? null,
        })
      )
    }

    if (this.isPreferencesComplete()) {
      const placeData = {
        filters: filterOptionIds,
      }

      const allowPetsOptionId = 24
      const disallowPetsOptionId = 25

      if (filterOptionIds.includes(allowPetsOptionId)) {
        placeData.petInfo = place.petInfo || ''
      } else if (filterOptionIds.includes(disallowPetsOptionId)) {
        placeData.petInfo = ''
      }

      formData.append('filters', JSON.stringify(filterOptionIds))
      formData.append('place', JSON.stringify(placeData))
    }

    // Property Details fields
    if (this.isPropertyDetailsComplete()) {
      formData.append(
        'place',
        JSON.stringify({
          ...place,
        })
      )
      formData.append('user', JSON.stringify(user))
    }

    // Upload Images fields
    if (this.isUploadImagesComplete()) {
      photos.forEach((item, index) => {
        const matchFile = photoBlobs[index]?.file || item.file
        formData.append(`file-${index}`, matchFile)
      })
      formData.append('captions', JSON.stringify(captions))
    }
  }

  handleSubmit = async () => {
    const { place, filterOptionIds, photos, captions, user, photoBlobs } =
      this.state

    this.setState({ loading: true, error: '', currencyError: '' })

    const formData = new FormData()
    this.addStepSpecificData(formData, {
      place,
      filterOptionIds,
      photos,
      captions,
      user,
      photoBlobs,
    })

    try {
      const response = await axios.post('/api/places', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      const { place: updatedPlace } = response.data

      await this.props.auth.handleLogin(response.data.data)

      const updatedTabCompletion = {
        listingInfo: this.isListingInfoComplete(),
        preferences: this.isPreferencesComplete(),
        propertyDetails: this.isPropertyDetailsComplete(),
        uploadImages: this.isUploadImagesComplete(),
      }

      const nextTab = this.getNextIncompleteTab(updatedTabCompletion)

      this.setState(
        {
          place: { ...updatedPlace },
          photos: response.data.placePhotos || [],
          captions: response.data.captions || [],
          filters: response.data.filters || [],
          filterOptionIds,
          currentStep: nextTab,
          tabCompletion: updatedTabCompletion,
        },
        () => {
          this.handleStepChange(nextTab)
        }
      )

      Notification({
        type: SUCCESS,
        message: `${this.state.pageText[4]}`,
      })
    } catch (error) {
      Notification({ data: error })
    } finally {
      this.setState({ loading: false })
    }
  }

  handlePhotosChange(imageList) {
    console.log(imageList)
    this.setState({
      photos: imageList,
    })
    this.state.photos.forEach((item, index) => {
      const file = item['file']
      if (file != undefined) {
        var tempArr = this.state.photoBlobs
        var tempArrItem = tempArr[index]
        const newItem = {
          data_url: item['data_url'],
          file: file,
        }
        tempArr.splice(index, 1, newItem)
        this.setState({
          photoBlobs: tempArr,
        })
      }
    })
  }

  getNextIncompleteTab = (isSectionComplete, currentStep) => {
    const steps = [
      'listingInfo',
      'preferences',
      'propertyDetails',
      'uploadImages',
    ]

    const currentStepIndex = steps.indexOf(currentStep)

    for (let i = currentStepIndex + 1; i < steps.length; i++) {
      if (!isSectionComplete[steps[i]]) {
        return steps[i]
      }
    }
    return steps.find((step) => !isSectionComplete[step]) || 'listingInfo'
  }

  handleImageRemove(index) {
    var localBlobs = this.state.photoBlobs
    localBlobs.splice(index, 1)
    var localCaptions = this.state.captions
    localCaptions.splice(index, 1)
    this.setState({
      photoBlobs: localBlobs,
      captions: localCaptions,
    })
  }

  handleCaptionsChange(event, index) {
    event.persist()
    this.setState((prevState) => {
      const updatedCaptions = [...prevState.captions]
      updatedCaptions[index] = { value: event.target.value }
      return {
        captions: updatedCaptions,
      }
    })
  }

  checkForErrors(errors) {
    if (errors) {
      if (errors.maxFileSize) {
        Notification({
          type: 'error',
          message: this.state.pageText[5],
        })
      }
    }
  }

  render() {
    const u = this.props.auth.user
    const p = this.state.place

    const countrySelected = this.state.countries.find(
      (c) => c.value === this.state.user.countryId
    )

    const citySelected = this.state.cities.find(
      (c) => c.value === this.state.user.locationId
    )
    const currencySelected = p
      ? this.state.currencies.find((c) => c.value === p.currencyId)
      : {}

    const typesOfPlaces = [
      { value: 0, label: 'Apartment' },
      { value: 1, label: 'House' },
      { value: 2, label: 'Other' },
    ]

    const livesOnPropertyOptions = [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ]

    const typeSelected = p
      ? typesOfPlaces.find((t) => t.label === p.typePlace)
      : {}

    const filters = this.state.allFilters
      .filter((f) => f.filterType !== 'range')
      .map((f) => {
        const isGuestPetsFilter = f.id === 7 // Check if the filter is "Can guests bring a pet?"

        const filterOptions = this.state.filterOptions
          .filter((o) => o.filterId === f.id)
          .map((o) => {
            return {
              name: o.id,
              label: o.filterOption,
              position: o.position,
              checked: this.state.filterOptionIds.includes(o.id),
            }
          })
          .sort((a, b) => a.position - b.position)

        return (
          <div key={f.display}>
            <CategoryFilterEdit
              label={f.display}
              type={f.filterType === 'radiobutton' ? 'radio' : f.filterType}
              handleChange={(e) => this.handleFilterChange(e, f.id)}
              options={filterOptions}
              checked={f.checked}
            />

            {isGuestPetsFilter && this.state.filterOptionIds.includes(24) && (
              <div className="form-group">
                <label>{this.state.pageText[6]}</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={this.state.place.petInfo}
                  onChange={(e) =>
                    this.setState((prevState) => ({
                      place: { ...prevState.place, petInfo: e.target.value },
                    }))
                  }
                />
              </div>
            )}
          </div>
        )
      })

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '15px',
        width: '100%',
        marginBottom: '10px',
        flexWrap: 'nowrap',
        outline: 'none',
        border: 'none',
      }),
    }

    const IntroSection = ({ p }) => {
      if (p.status) {
        if (p.status == 'place-approved') {
          return (
            <div className="profile-wrapper">
              <div>
                <p>{this.state.pageText[7]}</p>
              </div>
            </div>
          )
        }
      } else {
        return (
          <div className="profile-wrapper">
            <div>
              <p>
                {this.state.pageText[8]}
                <br />
                <br />
                {this.state.pageText[9]}
              </p>
            </div>
          </div>
        )
      }
    }

    if (!this.state.placeAlreadyExists) {
      return (
        <div className="card-body text-center">
          <div className="spinner-border homestays-spinner" role="status">
            <span className="sr-only">{this.state.pageText[10]}</span>
          </div>
          <p>{this.state.pageText[11]}</p>
        </div>
      )
    }

    const AddressProofSection = () => {
      if (this.state.placeAlreadyExists === 'y') {
        if (this.state.place.status === 'place-approved') {
          return (
            <div className="col-12 form-group">
              <div className="row pb-3 ml-1">
                <span className="badge badge-success">
                  <i className="fa fa-check" />
                  {this.state.pageText[12]}
                </span>
              </div>
              <hr />
            </div>
          )
        } else if (this.state.place.status === 'proof-uploaded') {
          return (
            <div className="col-12 form-group">
              <div className="row pb-3 ml-1">
                <span className="badge badge-warning">
                  <i className="fa fa-exclamation-triangle" />
                  {this.state.pageText[13]}
                </span>
              </div>
            </div>
          )
        } else {
          return (
            <div className="col-12 form-group proof-message">
              <div className="row pb-3 ml-1">
                <span className="badge badge-warning">
                  <i className="fa fa-exclamation-triangle" />
                  {this.state.pageText[14]}
                </span>
              </div>
              <p
                className="mb-4"
                dangerouslySetInnerHTML={{
                  __html: this.state.pageText[15],
                }}
              ></p>
              <p
                className="mb-4"
                dangerouslySetInnerHTML={{
                  __html: this.state.pageText[16],
                }}
              ></p>
              <ul className="list-disc list-inside pl-4 mb-4">
                <li>{this.state.pageText[17]}</li>
                <li>{this.state.pageText[18]}</li>
                <li>{this.state.pageText[19]}</li>
              </ul>
              <p
                dangerouslySetInnerHTML={{
                  __html: this.state.pageText[20],
                }}
              ></p>

              <div className="row ml-1">
                <Link to="/dashboard/edit-place/proof">
                  <button
                    className="btn"
                    style={{
                      backgroundColor: '#0BAC5D',
                      borderColor: '#0BAC5D',
                    }}
                  >
                    {this.state.pageText[21]}
                  </button>
                </Link>
              </div>
              <hr />
            </div>
          )
        }
      }
    }

    const steps = [
      'listingInfo',
      'preferences',
      'propertyDetails',
      'uploadImages',
    ]

    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              {this.state.propertySubmitted ? (
                <div className="container my-4">
                  <div className="row justify-content-center">
                    <div className="col-12">
                      <div className="thank-you-message p-4 border rounded bg-light">
                        <p className="mb-3">{this.state.pageText[22]}</p>
                        <p className="mb-4">{this.state.pageText[23]}</p>
                        <div className="d-flex flex-column align-items-center gap-2">
                          <Button
                            variant="success"
                            onClick={this.navigateToDashboard}
                            className="w-100 mb-2"
                          >
                            {this.state.pageText[24]}
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={this.editListingInfo}
                            className="w-100"
                          >
                            {this.state.pageText[25]}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <IntroSection p={p} />
                  <h3 className="title">{this.state.pageText[26]}</h3>
                  <TabsContainer
                    activeKey={this.state.currentStep}
                    onSelect={(step) => this.handleStepChange(step)}
                  >
                    <CustomNav variant="tabs" fill>
                      {steps.map((step) => {
                        const isActive = this.state.currentStep === step
                        const isCompleted = this.state.tabCompletion[step]
                        const Icon = isCompleted
                          ? FaCheckCircle
                          : FaExclamationCircle
                        const iconColor = isCompleted ? '#28a745' : '#ADADAD'
                        return (
                          <NavItemContainer key={step}>
                            <NavLinkContainer
                              eventKey={step}
                              active={isActive}
                              onClick={() => this.handleStepChange(step)}
                            >
                              <Icon
                                style={{ marginRight: '8px', color: iconColor }}
                              />

                              {step === 'listingInfo'
                                ? this.state.pageText[27]
                                : step === 'preferences'
                                  ? this.state.pageText[28]
                                  : step === 'propertyDetails'
                                    ? this.state.pageText[29]
                                    : step === 'uploadImages'
                                      ? this.state.pageText[30]
                                      : ''}
                            </NavLinkContainer>
                          </NavItemContainer>
                        )
                      })}
                    </CustomNav>

                    <Tab.Content>
                      {this.state.currentStep === 'listingInfo' && (
                        <Tab.Pane eventKey="listingInfo">
                          <div id="message" />
                          <form
                            method="POST"
                            action="/"
                            name="myForm"
                            aria-label="Edit Place"
                            onSubmit={(event) => {
                              event.preventDefault()
                              this.handleSubmit()
                              return false
                            }}
                          >
                            <input
                              type="hidden"
                              name="csrf-token"
                              value={window.Laravel.csrfToken}
                            />

                            {this.state.showProofOfAddress && (
                              <AddressProofSection />
                            )}

                            {this.state.place.status === 'place-approved' && (
                              <div className="col-12 form-group custom-control custom-switch custom-switch-md">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="visibility"
                                  checked={this.state.place.visibility}
                                  onChange={this.handlePlaceVisibility}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="visibility"
                                >
                                  {this.state.pageText[31]}
                                </label>
                              </div>
                            )}

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[32]}
                              </label>
                              <Select
                                id="livesOnProperty"
                                name="livesOnProperty"
                                styles={customStyles}
                                options={livesOnPropertyOptions}
                                value={livesOnPropertyOptions.find(
                                  (option) =>
                                    option.value ===
                                    this.state.place.livesOnProperty
                                )}
                                onChange={this.handleLivesOnPropertyChange}
                                placeholder={this.state.pageText[69]}
                              />

                              {this.state.place.status !== 'proof-uploaded' &&
                                this.state.place.status !== 'place-approved' &&
                                this.state.place.livesOnProperty &&
                                this.state.place.livesOnProperty === 'no' && (
                                  <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md shadow-sm max-w-md mx-auto mt-4">
                                    <h2 className="font-semibold text-base">
                                      {this.state.pageText[33]}
                                    </h2>
                                    <p
                                      className="mt-2 text-sm"
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.pageText[34],
                                      }}
                                    ></p>
                                    <ul className="mt-2 list-disc list-inside text-sm pl-4">
                                      <li
                                        dangerouslySetInnerHTML={{
                                          __html: this.state.pageText[35],
                                        }}
                                      ></li>
                                      <li
                                        dangerouslySetInnerHTML={{
                                          __html: this.state.pageText[36],
                                        }}
                                      ></li>
                                    </ul>
                                    <p
                                      className="mt-2 text-sm"
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.pageText[37],
                                      }}
                                    ></p>
                                  </div>
                                )}
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[38]}
                              </label>
                              <Select
                                id="typePlace"
                                name="typePlace"
                                className={`${
                                  this.state.propertyTypeError && 'red-border'
                                }`}
                                styles={customStyles}
                                value={typeSelected}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={false}
                                isRtl={false}
                                isSearchable={true}
                                required
                                options={typesOfPlaces}
                                onChange={this.handlePlaceTypeChange}
                              />
                              <hr />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: this.state.pageText[39],
                                }}
                              ></label>
                              <textarea
                                id="placeDescription"
                                name="placeDescription"
                                rows="5"
                                style={{ minWidth: '100%' }}
                                required
                                placeholder={this.state.pageText[70]}
                                value={this.state.place.placeDescription}
                                onChange={this.handlePlaceInputChange}
                              />
                              <hr />
                            </div>
                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: this.state.pageText[40],
                                }}
                              ></label>
                              <textarea
                                id="locationDescription"
                                name="locationDescription"
                                rows="5"
                                style={{ minWidth: '100%' }}
                                required
                                placeholder={this.state.pageText[71]}
                                value={this.state.place.locationDescription}
                                onChange={this.handlePlaceInputChange}
                              />
                              <hr />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[41]}
                              </label>

                              <Select
                                id="currencyId"
                                name="currencyId"
                                className={`${
                                  this.state.currencyError && 'red-border'
                                }`}
                                styles={customStyles}
                                value={currencySelected}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={false}
                                isRtl={false}
                                isSearchable={true}
                                options={this.state.currencies}
                                required
                                onChange={this.handleCurrencyChange}
                              />
                              <hr />
                            </div>
                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[42]}
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                name="hostPrice"
                                min="1"
                                step="1"
                                required
                                placeholder="0"
                                value={this.state.place.hostPrice}
                                onChange={this.handlePlaceInputChange}
                              />
                              <div
                                style={{
                                  display: 'block',
                                  alignItems: 'center',
                                  marginTop: '8px',
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    margin: '0',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.pageText[43],
                                  }}
                                ></p>
                                <p
                                  style={{
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    margin: '0',
                                  }}
                                >
                                  {' '}
                                  <strong>
                                    {freebirdFee}% {this.state.pageText[44]}
                                  </strong>
                                </p>
                              </div>
                              <hr />
                            </div>

                            <div className="d-flex justify-content-center gap-4 mb-3">
                              <Button
                                type="submit"
                                variant="primary"
                                disabled={this.state.loading}
                                className="px-4"
                              >
                                <i className="fa fa-save me-2" />{' '}
                                {this.state.pageText[45]}
                              </Button>
                              <Link
                                to="/dashboard/edit-place"
                                className="btn btn-danger text-decoration-none ml-3"
                              >
                                {this.state.pageText[46]}
                              </Link>
                            </div>

                            <br />
                            <Error error={this.state.error} />
                            {this.state.loading && (
                              <div className="col-12 form-group text-center">
                                <p className="info-flash d-flex align-items-center justify-content-center">
                                  <Spinner
                                    animation="border"
                                    role="status"
                                    className="me-2"
                                  />
                                  {this.state.pageText[47]}
                                </p>
                              </div>
                            )}
                          </form>
                        </Tab.Pane>
                      )}
                    </Tab.Content>

                    <Tab.Content>
                      {this.state.currentStep === 'preferences' && (
                        <Tab.Pane eventKey="preferences">
                          <div id="message" />
                          <form
                            method="POST"
                            action="/"
                            name="myForm"
                            aria-label="Edit Place"
                            onSubmit={(event) => {
                              event.preventDefault()
                              this.handleSubmit()
                              return false
                            }}
                          >
                            <input
                              type="hidden"
                              name="csrf-token"
                              value={window.Laravel.csrfToken}
                            />

                            <div className="filters">{filters}</div>

                            <div className="d-flex justify-content-center gap-4 mb-3">
                              <Button
                                type="submit"
                                variant="primary"
                                disabled={this.state.loading}
                                className="px-4"
                              >
                                <i className="fa fa-save me-2" />{' '}
                                {this.state.pageText[45]}
                              </Button>
                              <Link
                                to="/dashboard/edit-place"
                                className="btn btn-danger text-decoration-none ml-3"
                              >
                                {this.state.pageText[46]}
                              </Link>
                            </div>

                            <br />
                            <Error error={this.state.error} />
                            {this.state.loading && (
                              <div className="col-12 form-group text-center">
                                <p className="info-flash d-flex align-items-center justify-content-center">
                                  <Spinner
                                    animation="border"
                                    role="status"
                                    className="me-2"
                                  />
                                  {this.state.pageText[47]}
                                </p>
                              </div>
                            )}
                          </form>
                        </Tab.Pane>
                      )}
                    </Tab.Content>

                    <Tab.Content>
                      {this.state.currentStep === 'propertyDetails' && (
                        <Tab.Pane eventKey="propertyDetails">
                          <div id="message" />
                          <form
                            method="POST"
                            action="/"
                            name="myForm"
                            aria-label="Edit Place"
                            onSubmit={(event) => {
                              event.preventDefault()
                              this.handleSubmit()
                              return false
                            }}
                          >
                            <input
                              type="hidden"
                              name="csrf-token"
                              value={window.Laravel.csrfToken}
                            />

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: this.state.pageText[48],
                                }}
                              ></label>
                              <input
                                className="form-control"
                                id="address_line"
                                type="text"
                                name="address_line"
                                required
                                value={this.state.user.address_line}
                                onChange={this.handleUserInputChange}
                              />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: this.state.pageText[49],
                                }}
                              ></label>
                              <input
                                className="form-control"
                                id="second_address_line"
                                type="text"
                                name="second_address_line"
                                value={this.state.user.second_address_line}
                                onChange={this.handleUserInputChange}
                              />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[50]}
                              </label>

                              <Select
                                id="country"
                                name="country"
                                styles={customStyles}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={false}
                                isRtl={false}
                                isSearchable={true}
                                options={this.state.countries}
                                value={countrySelected}
                                required
                                onChange={this.handleCountryChange}
                              />
                              <hr />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[51]}
                              </label>

                              <Select
                                id="city"
                                name="city"
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: '48px',
                                    fontSize: '14px',
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    fontSize: '14px',
                                  }),
                                }}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={false}
                                isRtl={false}
                                isSearchable={true}
                                required
                                options={this.state.cities}
                                value={citySelected}
                                onChange={this.handleCityChange}
                              />

                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '8px',
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    margin: '0',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.pageText[52],
                                  }}
                                ></p>
                                <button
                                  style={{
                                    marginLeft: '8px',
                                    padding: '6px 12px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                  }}
                                  onClick={(e) => (
                                    e.preventDefault(),
                                    (window.location.href =
                                      'mailto:hello@thefreebirdclub.com?subject=City%20Not%20Listed')
                                  )}
                                >
                                  {this.state.pageText[53]}
                                </button>
                              </div>
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[54]}
                              </label>
                              <input
                                className="form-control"
                                id="county"
                                type="text"
                                name="county"
                                required
                                value={this.state.user.county}
                                onChange={this.handleUserInputChange}
                              />
                            </div>

                            <div className="col-12 form-group">
                              <label
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#495057',
                                }}
                              >
                                {this.state.pageText[55]}
                              </label>
                              <input
                                className="form-control"
                                id="postcode"
                                type="text"
                                name="postcode"
                                value={this.state.user.postcode}
                                onChange={this.handleUserInputChange}
                              />
                              <hr />
                            </div>

                            <div className="d-flex justify-content-center gap-4 mb-3">
                              <Button
                                type="submit"
                                variant="primary"
                                disabled={this.state.loading}
                                className="px-4"
                              >
                                <i className="fa fa-save me-2" />{' '}
                                {this.state.pageText[45]}
                              </Button>
                              <Link
                                to="/dashboard/edit-place"
                                className="btn btn-danger text-decoration-none ml-3"
                              >
                                {this.state.pageText[46]}
                              </Link>
                            </div>

                            <br />
                            <Error error={this.state.error} />
                            {this.state.loading && (
                              <div className="col-12 form-group text-center">
                                <p className="info-flash d-flex align-items-center justify-content-center">
                                  <Spinner
                                    animation="border"
                                    role="status"
                                    className="me-2"
                                  />
                                  {this.state.pageText[47]}
                                </p>
                              </div>
                            )}
                          </form>
                        </Tab.Pane>
                      )}
                    </Tab.Content>

                    <Tab.Content>
                      {this.state.currentStep === 'uploadImages' && (
                        <Tab.Pane eventKey="uploadImages">
                          <form
                            method="POST"
                            action="/"
                            name="myForm"
                            aria-label="Edit Place"
                            onSubmit={(event) => {
                              event.preventDefault()
                              this.handleSubmit()
                              return false
                            }}
                          >
                            <input
                              type="hidden"
                              name="csrf-token"
                              value={window.Laravel.csrfToken}
                            />

                            <div className="col-12 mb-4">
                              <div className="col-12 mb-4">
                                <h6 className="fw-bold images-title">
                                  {this.state.pageText[56]}
                                </h6>
                                <p className="mb-2 images-text">
                                  {this.state.pageText[57]}
                                </p>
                                <p
                                  className="images-text text-muted"
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.pageText[58],
                                  }}
                                ></p>
                              </div>

                              <div className="col-12 image-uploading">
                                <ImageUploading
                                  multiple
                                  value={this.state.photos}
                                  onChange={this.handlePhotosChange}
                                  maxNumber={10}
                                  dataURLKey="data_url"
                                  acceptType={['jpg', 'png', 'jpeg']}
                                  maxFileSize={4000000}
                                  onError={this.checkForErrors}
                                >
                                  {({
                                    onImageUpload,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                  }) => (
                                    <div className="image-uploading__image-wrapper">
                                      <div
                                        className="add-photos text-center mb-3"
                                        style={
                                          isDragging ? { color: 'red' } : null
                                        }
                                        onClick={(e) => {
                                          e.preventDefault()
                                          onImageUpload()
                                        }}
                                        {...dragProps}
                                      >
                                        <div>{this.state.pageText[59]}</div>
                                        <Button
                                          variant="success"
                                          className="mt-2"
                                        >
                                          {this.state.pageText[60]}
                                        </Button>
                                      </div>

                                      {this.state.photos.map((image, index) => (
                                        <div
                                          key={index}
                                          className="image-container mb-3"
                                        >
                                          <div className="image-item">
                                            <img
                                              src={image.data_url}
                                              alt=""
                                              width="100%"
                                              className="img-thumbnail mb-2"
                                            />
                                            <div className="image-item__input-holder mt-2">
                                              <span className="small">
                                                {this.state.pageText[61]}
                                              </span>
                                              <textarea
                                                className="form-control mt-1"
                                                rows="2"
                                                name="placePhotoDescription"
                                                value={
                                                  this.state.captions[index]
                                                    ? this.state.captions[index]
                                                        .value
                                                    : ''
                                                }
                                                onChange={(event) =>
                                                  this.handleCaptionsChange(
                                                    event,
                                                    index
                                                  )
                                                }
                                              />

                                              <div className="d-flex justify-content-around align-items-center mt-3">
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  className="d-flex align-items-center gap-1 mr-3"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    onImageRemove(index)
                                                    this.handleImageRemove(
                                                      index
                                                    )
                                                  }}
                                                >
                                                  <FaTrash />{' '}
                                                  {this.state.pageText[62]}
                                                </Button>

                                                <Button
                                                  variant="outline-primary"
                                                  size="sm"
                                                  className="d-flex align-items-center gap-1"
                                                  onClick={(e) => {
                                                    e.preventDefault()
                                                    onImageUpdate(index)
                                                  }}
                                                >
                                                  <FaEdit />{' '}
                                                  {this.state.pageText[63]}
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </ImageUploading>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center gap-4 mb-3">
                              <Button
                                type="submit"
                                variant="primary"
                                disabled={this.state.loading}
                                className="px-4"
                              >
                                <i className="fa fa-save me-2" />{' '}
                                {this.state.pageText[64]}
                              </Button>
                              <Link
                                to="/dashboard/edit-place"
                                className="btn btn-danger text-decoration-none ml-3"
                              >
                                {this.state.pageText[46]}
                              </Link>
                            </div>

                            <p className="text-muted small mt-3 add-photos-warning">
                              {this.state.pageText[65]}{' '}
                              <a
                                href="#"
                                onClick={(e) => (
                                  e.preventDefault(),
                                  (window.location.href =
                                    'mailto:hello@thefreebirdclub.com?subject=Homestay%20Photos%20Upload%20Problem')
                                )}
                              >
                                {this.state.pageText[66]}
                              </a>{' '}
                              {this.state.pageText[67]}
                            </p>

                            <Error error={this.state.error} />

                            {this.state.loading && (
                              <div className="col-12 form-group text-center mt-3">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="me-2"
                                />
                                <span>{this.state.pageText[68]}</span>
                              </div>
                            )}
                          </form>
                        </Tab.Pane>
                      )}
                    </Tab.Content>
                  </TabsContainer>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withSearch(withAuth(EditPlace)))
